import { TrixHelpers } from './trix_config'

$(function() {
  // Cached variables
  var $canned_comment_modal = $('#canned_comment_modal');
  var $comment_search_terms = $('#comment_search_terms');
  var $btn_search_comment   = $('#btn_search_comment');
  var $comment_item_list    = $('#comment_item_list');

  /** Trap keyboard input and display canned comments modal */
  jwerty.key('ALT + C', function(e) {
    // If alt+c is pressed avoid typing latin cedilla character
    e.preventDefault();
    //On show modal if current cusor focus on a textarea/wysiwyg input
    if ($(":focus").is("textarea") || $(":focus").hasClass("fr-element") || $(":focus").is("trix-editor")) { 
      $(":focus").addClass("focused");
      $canned_comment_modal.modal('show');
    }
  });

  /**
   * On modal show - set search bar in focus
   * On modal hide - reset the modal
   */
  $canned_comment_modal.on('shown.bs.modal', function () {
    $comment_search_terms.focus();
  }).on('hide.bs.modal', function(e) {
    $comment_search_terms.val("");
    $('.focused').removeClass('focused');
    $comment_item_list.empty();


  }).on('hidden.bs.modal', function(e) {
    // Hack to enable multiple modals by making sure the .modal-open class
    // is set to the <body> when there is at least one modal open left
    if ($('.modal:visible').length) {
      $('body').addClass('modal-open');
    }
  });

  /** Allow search by hitting enter in search terms input */
  $comment_search_terms.on('keydown', function(e) {
    var ENTER = 13;
    if (e.which == ENTER) {
      $btn_search_comment.trigger('click');
      e.preventDefault();
    }
  });

  /** Search buttons should perform the search on click */
  $btn_search_comment.on('click', function(e) {
    search();
    e.preventDefault();
  });

  /** Ajax call to search canned comments */
  function search() {
    //Get search data
    var data = $comment_search_terms.val();
    $.ajax({
      url: '/canned_comments/show_comments.json',
      type: 'GET',
      data: { term: data },
      dataType: 'json',
      cache: false
    }).done(function(data) {
      //Empty result list
      $comment_item_list.empty();
      //If no records found return alert
      if (data.length == 0) {
        $comment_item_list.append('<div class="alert alert-danger">No records found.</div>');
      } else {
        //Create table for results and display in result list
        var $tbl = $('<table class="table table-striped"></table>');
        $comment_item_list.append($tbl);
        $.each(data, function() {
          var labels = buildLabel(this);
          var $tr = $('<tr></tr>');
          var $displaystr = _.first(labels);
          $tr.append('<td>' + $displaystr + '</td>');          
          $tr.append('<td><span class="btn btn-light pick-comment-button" href="#" data-id="'+ this.value +'">Select</span></td>');
          $tbl.append($tr);
        });
      }
    });
  }

  /** Function to build canned comment label for display in modal */
  function buildLabel(data) {
    var label = '';
    var short_name = data.short_name
    var comment = data.comment
    //Return blank string if comment is null
    if ( comment == null) {
      comment = ''
    } else if (comment.length > 150) {
      //Truncate the comment if it has a length greater than 150 characters
      comment = $.trim(comment).substring(0, 150)
                   .trim(this) + "...";
    }
    label = '<strong>'+ short_name +'</strong><br/>'+ comment;
    return [label];
  }

  /** When select button is clicked load correct canned comment based on ID */
  $(document).on('click', '.pick-comment-button', function(e) {
    var $this = $(this);
    loadComment($this.data('id'));
    e.preventDefault();
  });

  /** Load a canned comment with specific ID */
  function loadComment(id) {
    $.ajax({
      url:  '/canned_comments/' + id + '.json',
      type: 'GET',
      data: { id: id },
      dataType: 'json',
      cache: false
    }).done(function(data) {
      setElementValue(data.comment, {name: data.short_name});
      $canned_comment_modal.modal('hide');
    });
  }

  function appendHTMLToTrixEditor(editor, html, {name} = {}) {
    TrixHelpers.undoableManipulationWithEditor(
      editor,
      [$.t('Appended {{label}}', {label: name})],
      e => TrixHelpers.restoreSelectionInEditorAfter(
        e,
        e => TrixHelpers.appendHTMLToEditor(e, html)
      )
    );
  }

  function appendHTMLToTextarea(textarea, html) {
    $(textarea).val(
      $.isBlank($(textarea).text()) ? html : $(textarea).val() + html
    );
  }

  /** Set focused textarea element with canned comment text */
  function setElementValue(data, {name} = {}) {
    let lazyMungedHTML;
    const mungedHTML = () => lazyMungedHTML ??= data.replace(/<\/p>/g,'<br></div>').replace(/<p>/g,'<div>');

    _.each($('.focused'), function(value, idx) {
      if (value.tagName === 'TRIX-EDITOR') {
        appendHTMLToTrixEditor(value.editor, data, {name});
      }
      else {
        appendHTMLToTextarea(value, mungedHTML());
      }

      $(value).removeClass('focused');
      $(value).focus();
    });
  }
});